<template>
  <!--/*缅怀英烈，守护有我*/-->
  <div class="maprotation">
    <div class="contentnr">
      <div class="content">
        <div class="content-wrapplay">
          <ul class="content-wrapplay-list" v-for="(item,index) in areaylist" :key="index">
            <li v-for="(ite,ind) in item" :class="activeClass == ind?'active':''" @click="handleImgShow(ite)"
                :key="ind">
              <img  :src="ite.urlvalue">
              {{ite.name}}
            </li>
          </ul>
          <div class="content-wrapplay-theme">
            <div class="cityname">{{citytext}}</div>
            <div class="cityxq">
              <p class="citydata">至 <span>{{citytime}}</span></p>
              <p class="citydata"><span>{{cityzt}}</span> 人次参与线上专题活动</p>
              <p class="citydata"><span>{{cityyjs}}</span> 人次参与“云祭扫”</p>
              <p class="citydata">最新活动动态 <span>{{citzxhd}}</span> 篇</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {getmaptiondata} from "@/api/maprotation.js"

  export default {
    data() {
      return {
        activeClass: -1,
        citytext: "",
        citytime: "",
        cityzt: "",
        cityyjs: "",
        citzxhd: "",
        areaylist: [],
        areay: [],
      }
    },
    mounted() {
      this._initdata();
      setTimeout(() => {
        $('.content-wrapplay-list li').each(function () {
          $(this).click(function () {
            $('.content-wrapplay-list li').removeClass('active')
            $(this).addClass('active')
          })
        })
      }, 200)
    },
    components: {},
    methods: {
      _initdata() {
        getmaptiondata().then((res)=>{
          if(res.code == 200){
            this.areay = res.data.slice(0,32)
            this.areay.forEach((item)=>{
              if(item.value == '640000000000'||item.value == '450000000000'||item.value=="540000000000"){
                item.name = item.name.slice(0,2)
              }else if(item.value=='150000000000'){
                item.name = item.name.slice(0,3)
              }else if(item.value=='650000000000'||item.value=='660000000000'){
                if(item.value=='650000000000'){
                  item.name = item.name.slice(0,2)
                }
                if(item.value=='660000000000'){
                  item.name = item.name.substring((item.name.length-2),item.name.length)
                }
              }
            })
            this.handleQg()
          }
        }).catch(()=>{

        })
      },
      handleQg(){
        var a_len = this.areay.length;
        var num = 8
        var result = [];
        var data = []
        var datalist = this.areay.slice(num, a_len - num)
        this.areaylist.push(this.areay.slice(0, num));
        this.group(datalist, 2, this.areaylist);
        this.areaylist.push(this.areay.slice(a_len - num, a_len))
      },
      group(array, subGroupLength, result) {
        let index = 0;
        let newArray = [];
        while (index < array.length) {
          result.push(array.slice(index, index += subGroupLength));
        }
        this.handleImgShow(this.areay[0])
      },
      handleImgShow(item) {
        this.citytext = item.name
        this.citytime = item.citytime
        this.cityzt = item.cityzt
        this.cityyjs = item.cityyjs
        this.citzxhd = item.citzxhd
      },
    },

  }
</script>
<style scoped>
  @media screen and (max-width:1366px) {
    .content-wrapplay-list > li {
      font-size: 20px !important;
    }
    .cityname{
      font-size: 55px;
    }
    .citydata{
      font-size: 45px;
    }
    .citydata > span{
      font-size: 50px;
    }
  }
  .active {
    background-color: #094117;
  }

  .maprotation {
    height: 100%;
    text-align: center;
  }

  .content-wrapplay {
    position: relative;
    margin-top: 80px;
    width: 1066px;
    display: flex;
    height: 590px;
    flex-direction: column;
    border-radius: 10px;
    justify-content: space-between;
    overflow: hidden;
    border: 1px solid #094117;
    background: url("../../../assets/img/bg_text.png");
  }

  .content-wrapplay-theme {
    position: absolute;
    width: 800px;
    height: 472px;
    left: 133.25px;
    top: 60px;
    background: url("../../../assets/img/listcentenimg.png");
    background-size: 100% 100%;

  }

  .content-wrapplay-list {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    vertical-align: text-bottom;
  }

  .content-wrapplay-list > li {
    display: block;
    padding: 0;
    margin: 0;
    width: 133.25px;
    text-align: center;
    box-sizing: border-box;
    border-right: 1px #094117 solid;
    border-bottom: 1px #094117 solid;
    margin-bottom: -1px !important;
    height: 60px;
    line-height: 60px;
    cursor: pointer;
    color: #e2e2e2;
    font-size: 16px;
    box-sizing: border-box;
    vertical-align: inherit;

  }

  .content-wrapplay-list > li:last-child {
    border-right: none !important;
  }

  .content-wrapplay-list > li:hover {
    background-color: #094117;
  }

  .content-wrapplay-list > li > img {
    display: inline-block;
    height: 30px;
    width: 30px;
    vertical-align: inherit;

  }

  .content-wrapplay-list:last-child {
    border-right: none !important;
  }

  .content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;

  }

  .contentnr {
    width: 100%;
    height: 100%;
    float: left;
    padding-top: 100px;
    box-sizing: border-box;
  }

  .cityname {
    position: absolute;
    left: 50%;
    top: 30px;
    transform: translateX(-50%);
    z-index: 1000;
    color: white;
    font-size: 50px;
  }

  .cityxq {
    margin: 120px 0 0 0;
  }

  .citydata {
    color: white;
    font-size: 40px;
    margin: 0;
  }

  .citydata > span {
    font-weight: bold;
    font-size: 45px;
    color: #f3d180;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home/components/maprotation.vue